import { useMediaQuery } from "@mui/material";
import { useQueryProductId } from "services/api/queries/useQueryProduct";
import { IProduct } from "types/Product";
import { useTheme } from "@mui/system";
import FoodDialogLoading from "./FoodDialogLoading";
import FoodDialogForm from "./FoodDialogForm";
import FoodDialogForMenu from "./FoodDialogForMenu";
import FoodDialogError from "./FoodDialogError";
import { UseQueryResult } from "react-query";
import { IShoppingBagData } from "../../types/ShoppingBag";
import { useLocation } from "react-router-dom";
import { IPlaceData } from "../../types/Place";

type Props = {
  open: boolean;
  handleClose: () => void;
  product: IProduct;
  shoppingBagQuery: UseQueryResult<IShoppingBagData>
  placeInfo: IPlaceData | undefined
};

/**
 * Gerencia e se responsabiliza por:
 *  - temos os dados de produto necessários?
 *  - exibição dos estados de loading, erro, carrinho vazio.
 * O form onde o cliente pode montar o
 * produto e adicionar ao carrinho, é delegada para componentes específicos.
 * @param open
 * @param handleClose
 * @param product
 * @param isShoppingBagLoading
 * @constructor
 */
function FoodDialog({ open, handleClose, product, shoppingBagQuery,placeInfo }: Props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { isLoading: productDataIsLoading,
    isError: productDataIsError,
    isFetching: productDataIsFetching,
    isRefetching: productDataIsRefetching,
    data: apiProductData,
    refetch: productDataRefetch
  } = useQueryProductId(product.id);

  const {data:shoppingBag} = shoppingBagQuery

  const location = useLocation();



  const placeEstaFechado = placeInfo?.closed ?? true

  // LOADING
  if(productDataIsLoading || productDataIsFetching || productDataIsRefetching || !shoppingBag){
    return (<FoodDialogLoading
      fullScreen={fullScreen}
      handleClose={handleClose}
      open={open} />)
  }

  // ERRO
  if(productDataIsError || apiProductData === null || apiProductData === undefined) {
    return (<FoodDialogError
      fullScreen={fullScreen}
      handleClose={handleClose}
      open={open} />)
  }

  // TEMOS O DADO É SÓ CARDÁPIO
  if(location.pathname === "/cardapio"){
    return (<FoodDialogForMenu
      apiProductData={apiProductData}
      productDataRefetch={productDataRefetch}
      product={product}
      fullScreen={fullScreen}
      handleClose={handleClose}
      open={open}
    />)
  }

  // TEMOS O DADO E É PARA FAZER PEDIDO
  return (<FoodDialogForm
    shoppingBag={shoppingBag}
    apiProductData={apiProductData}
    productDataRefetch={productDataRefetch}
    product={product}
    fullScreen={fullScreen}
    handleClose={handleClose}
    open={open}
    placeEstaFechado={placeEstaFechado}
  />)
}

export default FoodDialog;
